/**
 * Created by Ning Jiang on 11/17/2016.
 */

import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require("pixi-spine");

import {gsap} from "gsap";
import {CustomEase} from "gsap/dist/CustomEase";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
gsap.registerPlugin(CustomEase, CustomWiggle);

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {DeadwoodRip} from "./game/DeadwoodRip";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {DeadwoodRipIntroConfig} from "./game/intro/DeadwoodRipIntroConfig";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DeadwoodRipPromoPanelConfig} from "./game/DeadwoodRipPromoPanelConfig";

declare global {
    interface Window {
        NolimitLauncher:NolimitLauncher;
    }
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.settings.log = LogLevel.DEV;
NolimitLauncher.instance.launch([
    new DeadwoodRip(),
    new SlotKeypad(),
    new NolimitGameIntroPlugin(new DeadwoodRipIntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new DeadwoodRipPromoPanelConfig())
]);
